import { formatCurrency, getCurrencySymbol } from '@angular/common';
import {
  HostListener,
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ListaPrecoTabelaService } from '../../../../../shared/services/lista-preco-tabela.service';
import { Utils } from '../../../../../utils/utils';
import { BehaviorSubject, Observable, Subject, timer } from 'rxjs';
import { debounceTime, finalize, retry, share, switchMap, takeUntil, tap, filter, map, delay } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { CST } from '../../../../../shared/inmemory-db/cst';
import { ModalidadeFrete } from '../../../../../shared/inmemory-db/modalidade-frete';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { Condpg } from '../../../../../shared/interfaces/condpg';
import { Estado } from '../../../../../shared/interfaces/estado';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { FatDoctoCCce } from '../../../../../shared/interfaces/fat-docto-cc-ce';
import { FatDoctoI, ItemID } from '../../../../../shared/interfaces/fat-docto-i';
import { FatDoctoRef } from '../../../../../shared/interfaces/fat-docto-ref';
import { FatSerie } from '../../../../../shared/interfaces/fat-serie';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { ListaPreco } from '../../../../../shared/interfaces/lista-preco';
import { ListaPrecoTabela } from '../../../../../shared/interfaces/lista-preco-tabela';
import { Log } from '../../../../../shared/interfaces/log';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Produto } from '../../../../../shared/interfaces/produto';
import { Transacao } from '../../../../../shared/interfaces/transacao';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from '../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { LancamentoItemDIListComponent } from '../lacamento-item-di-list/lancamento-item-di-list.component';
import { LancamentoItemDetailsComponent } from '../lancamento-item-details/lancamento-item-details.component';
import { ProdutoPopupComponent } from '../../../../cadastro/faturamento/produto/produto-popup/produto-popup.component';
import { ProdutoDetailsComponent } from '../../../../cadastro/faturamento/produto/produto-details/produto-details.component';
import { ProdutoManutencaoPrecoComponent } from '../../../../cadastro/faturamento/produto-manutencao-preco/produto.manutencao.preco.component';

@Component({
  selector: 'app-lancamento-itens',
  templateUrl: 'lancamento-itens.component.html',
  styleUrls: ['lancamento-itens.component.scss'],
})
export class LancamentoItensComponent implements OnInit, OnDestroy {
  sortDir = { codigo: 'asc' as 'asc' | 'desc', descricao: 'asc' as 'asc' | 'desc' };
  lctoItens = '';
  protected _onDestroy = new Subject<void>();

  @ViewChild(MatPaginator, { static: false }) paginatorItem: MatPaginator;
  @ViewChild('ngxDatatable') ngxDatatable: DatatableComponent;
  @ViewChild('produtoSearch') produtoSearchInput: ElementRef;

  public doctoCForm: FormGroup;
  doctoIForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  modalidadesFrete: any[];
  estados: Estado[];
  CST = new CST();
  lcto: FatDoctoC;
  selectedTabIndex = 0;

  fatTransacoes: Transacao[];
  fatTransacao: Transacao;
  isLoadingFatTransacao = false;

  produtos: Produto[] = [];
  produtos$: BehaviorSubject<Produto[]> = new BehaviorSubject<Produto[]>([]);
  produto!: Produto;
  isLoadingProduto = false;

  series: FatSerie[];
  serie: FatSerie;
  isLoadingSerie = false;

  doctoCs: FatDoctoC[];
  doctoC: FatDoctoC;
  isLoadingDoctoC = false;

  destinatarios: Cadastro[];
  destinatario: Cadastro;
  isLoadingDestinatario = false;

  vendedores: Cadastro[];
  vendedor: Cadastro;
  isLoadingVendedor = false;

  transps: Cadastro[];
  transp: Cadastro;
  isLoadingTransp = false;

  motoristas: Cadastro[];
  motorista: Cadastro;
  isLoadingMotorista = false;

  condPgs: Condpg[];
  condPg: Condpg;
  isLoadingCondPg = false;

  listaPrecos$: BehaviorSubject<ListaPreco[]> = new BehaviorSubject<ListaPreco[]>([]);
  listaPreco: ListaPreco;
  isLoadingPreco = false;

  tabelas$: BehaviorSubject<ListaPrecoTabela[]> = new BehaviorSubject<ListaPrecoTabela[]>([]);
  tabela: ListaPrecoTabela;
  isLoadingTabela = false;

  pageObjectDoctoI$: BehaviorSubject<PageResult<FatDoctoI>> = new BehaviorSubject<PageResult<FatDoctoI>>(null);
  searchEntry$: Subject<string> = new Subject<string>();
  produtoItemExists$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  doctoIs: FatDoctoI[];
  doctoIs$: BehaviorSubject<FatDoctoI[]> = new BehaviorSubject<FatDoctoI[]>([]);
  doctoI: FatDoctoI;
  saveItem = false;
  page = { offset: 0 };
  pageItem = 1;
  lengthItem = 0;
  pageSizeItem = 30;
  pageEventItem = null;
  pageSizeOptionsItem: number[] = [5, 10, 30, 50, 100, 500, 1000];
  selectedItemOrdem = 'issueDate';  
  selectedItemDirect = 'DESC';  
  public searchInput = '';

  mouseoverAutoriza = false;
  mouseoverCancela = false;
  errorMsg: string;

  maskFone = { mask: '(00) {*}0000-0000', lazy: true, placeholderChar: '_' };
  maskCep = { mask: '00000-000', lazy: true, placeholderChar: '_' };
  maskCfop = { mask: '0000', lazy: true, placeholderChar: '_' };
  maskCpf = { mask: '000.000.000-00', lazy: true, placeholderChar: '_' };
  maskCnpj = { mask: '00.000.000/0000-00', lazy: true, placeholderChar: '_' };
  maskUpper = { mask: /^\w\s*/, prepare: (str: any) => str.toUpperCase() };
  maskLower = { mask: /^\w\s*/, prepare: (str: any) => str.toLowerCase() };
  maskEmail = { mask: /^\S*@?\S*$/, prepare: (email: any) => email.toLowerCase() };

  newItem = {} as FatDoctoI;
  isEditableDoctI = {};
  isEditableParcela = {};
  parcelas: FinancRp[] = new Array();
  private stopPolling = new Subject();
  precoPadrao: any;
  refs: FatDoctoRef[];
  cartaCorrecoes: FatDoctoCCce[];
  controle: any;
  showEditOption: boolean;
  openModal = false;
  deniedInitData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  utils = Utils;
  max = null;
  workDone = null;
  it = 0;
  maxRetry = 20;
  created = false;
  disabled: true;
  public layoutConf: any;
  public searching = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItensComponent>,
    @Inject(LOCALE_ID) private locale: string,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private produtoService: ProdutoService,
    private cadastroService: CadastroService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private progressLoader: AppLoaderProgressService,
    private renderer: Renderer2,
    private layout: LayoutService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {
    this.modalidadesFrete = new ModalidadeFrete().modalidades;
    this.estados = new Estados().estados;
  }

  ngOnInit() {
    console.log('INIT LIST ITENS');
    this.layoutConf = this.layout.layoutConf;
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;
    this.controle = this.lcto?.controle;

    this.doctoIs$.subscribe((log) => {
      this.doctoIs = log.map((val) => val);
    });

    this.reloadLctoItens(this.lcto);

    this.pageObjectDoctoI$.subscribe((page) => {
      this.doctoCForm.setControl('items', this.fb.array([]));
      console.log('this.pageObjectDoctoI$.subscribe');
      if (page != null) {
        this.zone.run(() => {
          this.doctoIs$.next(page.content);
        });
        this.doctoIs = page.content;
        this.lengthItem = page.totalElements;
        this.pageSizeItem = page.size;
        this.pageItem = page.number;
        page.content.forEach((i) => {
          this.addDoctoI(i);
        });
        this.doctoCForm.setControl('items', this.itemFormArray);
        if (this.pageItem === 1) {
          this.paginatorItem.firstPage();
        }
      } else {
        this.doctoIs = [];
        this.doctoIs$.next([]);
      }
      this.loader.close();
    });

    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
    this.debounceTimeSearchItem();

    this.doctoCForm
      .get('produtoSearch')
      ?.valueChanges.pipe(
        filter((search) => !!search),
        tap(() => (this.searching = true)),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map((search) => {
          return this.produtoService
            .getProdutoPageSearch(1, 10, search, 'NENHUM', 'ASC', false, false)
            .subscribe((page) => {
              this.produtos = page.content;
            });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        (result) => {
          this.searching = false;
        },
        (error) => {
          this.searching = false;
          this.confirmService.confirm({
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO PRODUTO ... ${error}`,
            error: true,
          });
        }
      );
  }

  reloadLctoItens(lcto: FatDoctoC) {
    this.lctoItens =
      'CONTROLE:' +
      lcto.controle +
      ' - TOTAL DO LCTO:' +
      formatCurrency(lcto.valortotalDocto, this.locale, getCurrencySymbol('BRL', 'wide'));
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.ngxDatatable) {
        this.ngxDatatable.recalculate();
        this.ngxDatatable.recalculateColumns();
        setTimeout(() => {
          this.ngxDatatable.recalculate();
        }, 100);
      }
    }, 0);

    this.dialogRef.afterOpened().subscribe(() => {
      const resizeObserver = new ResizeObserver(() => {
        if (this.ngxDatatable) {
          this.ngxDatatable.recalculate();
          this.ngxDatatable.recalculateColumns();
        }
      });
      resizeObserver.observe(document.querySelector('.mat-dialog-container') as Element);
      this._onDestroy.subscribe(() => resizeObserver.disconnect());
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.stopPolling.next();
    this.stopPolling.complete();
  }

  reloadFormItens() {
    this.doctoCForm.setControl('items', this.fb.array([]));
    this.doctoIs.forEach((i) => {
      this.addDoctoI(i);
    });
    this.doctoCForm.setControl('items', this.itemFormArray);
  }

  addDoctoI(doctoI: FatDoctoI) {
    console.log('ITEM>' + this.codigoCst(doctoI.icmsClasstrib ?? ''));
    this.itemFormArray.push(
      this.fb.group({
        id: [doctoI.id],
        uuid: [doctoI.uuid],
        produto: [doctoI?.id.fatProduto],
        qtde: [doctoI.qtde],
        valorUnitario: [doctoI.valorUnitario],
        valorTotal: [doctoI.valorTotal],
        descPercUnitario: [doctoI.descPercUnitario],
        descValorUnitario: [doctoI.descValorUnitario],
        valorUnitarioLiquido: [doctoI.valorUnitarioLiquido],
        valorTotalLiquido: [doctoI.valorTotalLiquido],
        tabcfopId: [doctoI.tabcfopId],
        icmsClasstrib: [doctoI.icmsClasstrib],
        icmsDigitacaomanual: [doctoI.icmsDigitacaomanual],
        icmsBasecalculo: [doctoI.icmsBasecalculo],
        icmsPerc: [doctoI.icmsPerc],
        icmsValor: [doctoI.icmsValor],
        ipiDigitacaomanual: [doctoI.ipiDigitacaomanual],
        ipiPercentual: [doctoI.ipiPercentual],
        ipiValor: [doctoI.ipiValor],
        infAdProd: [doctoI.infAdProd],
        importacaoValorBaseCalculo: [doctoI.importacaoValorBaseCalculo],
        importacaoValorDespesaAduaneira: [doctoI.importacaoValorDespesaAduaneira],
        importacaoValorImpostoImportacao: [doctoI.importacaoValorImpostoImportacao],
        importacaoValorIOF: [doctoI.importacaoValorIOF],
        informaImpostoImportacao: [doctoI.informaImpostoImportacao],
        beneficioFiscal: [doctoI.beneficioFiscal],
        codigoBeneficioFiscalUF: [doctoI.codigoBeneficioFiscalUF],
      })
    );
  }

  codigoCst(codgo: string): string {
    return this.CST.getByCodJkaw(codgo ?? '')?.codigo ?? '';
  }

  get itemFormArray(): FormArray {
    return this.doctoCForm.get('items') as FormArray;
  }

  enterPressedOnValorUnLiq() {
    console.log('enterPressedOnValorUnLiq');
    this.produtoSearchInput.nativeElement.focus();
    this.produtoSearchInput.nativeElement.select();
  }

  changeQtdeOrValorUnitario(row: FormGroup) {
    const newValorTotal = row.controls['valorUnitario'].value * row.controls['qtde'].value;
    if (row.controls['valorTotal'].value !== newValorTotal) {
      row.controls['valorTotal'].setValue(newValorTotal);
    }
  }

  changeValorTotal(row: FormGroup) {
    if (row.controls['qtde'].value === 0 && row.controls['valorUnitario'].value > 0) {
      const newQtde = row.controls['valorTotal'].value / row.controls['valorUnitario'].value;
      console.log('newQtde>>>>>>>' + newQtde);
      if (row.controls['qtde'].value !== newQtde) {
        row.controls['qtde'].setValue(newQtde);
      }
    } else if (row.controls['qtde'].value > 0 && row.controls['valorUnitario'].value === 0) {
      const newValorUnitario = row.controls['valorTotal'].value / row.controls['qtde'].value;
      if (row.controls['valorUnitario'].value !== newValorUnitario) {
        row.controls['valorUnitario'].setValue(newValorUnitario);
        console.log('valorUnitario>>>>>>>' + row.controls['valorUnitario'].value);
      }
    } else {
      const newValorTotal = row.controls['valorUnitario'].value * row.controls['qtde'].value;
      if (row.controls['valorTotal'].value !== newValorTotal) {
        row.controls['valorTotal'].setValue(newValorTotal);
        row.controls['valorUnitarioLiquido'].setValue(
          row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
        );
        row.controls['valorTotalLiquido'].setValue(
          row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
        );
        console.log('valorUnitarioLiquido>>>>>>>' + row.controls['valorUnitarioLiquido'].value);
        console.log('valorTotalLiquido>>>>>>>' + row.controls['valorTotalLiquido'].value);
      }
    }
  }

  changeDescPercUnitario(row: FormGroup) {
    row.controls['descValorUnitario'].setValue(
      (row.controls['valorUnitario'].value * row.controls['descPercUnitario'].value) / 100
    );
    row.controls['valorUnitarioLiquido'].setValue(
      row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
    );
    row.controls['valorTotalLiquido'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
    if (!row.controls['icmsDigitacaomanual'].value) {
      row.controls['icmsBasecalculo'].setValue(
        row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
      );
    }
    row.controls['icmsBasecalculo'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
  }

  changedescValorUnitario(row: FormGroup) {
    row.controls['descPercUnitario'].setValue(
      (row.controls['descValorUnitario'].value / row.controls['valorUnitario'].value) * 100
    );
    row.controls['valorUnitarioLiquido'].setValue(
      row.controls['valorUnitario'].value - row.controls['descValorUnitario'].value
    );
    row.controls['valorTotalLiquido'].setValue(
      row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
    );
    if (!row.controls['icmsDigitacaomanual'].value) {
      row.controls['icmsBasecalculo'].setValue(
        row.controls['valorUnitarioLiquido'].value * row.controls['qtde'].value
      );
    }
  }

  enterPressedOnIcmsBaseCalculo(row: FormGroup) {
    console.log('enterPressedOnIcmsBaseCalculo');
  }

  selectIcmsBaseCalculo(event: any) {
    console.log('selectIcmsBaseCalculo');
  }

  selectIpiValor(event: any) {
    console.log('selectIpiValor');
  }

  changeIcmsPercentual(row: FormGroup) {
    row.controls['icmsValor'].setValue(
      (row.controls['icmsBasecalculo'].value * row.controls['icmsPerc'].value) / 100
    );
  }

  changeIpiPercentual(row: FormGroup) {
    console.log('changeIpiPercentual' + row.controls['valorTotalLiquido'].value);
    row.controls['ipiValor'].setValue(
      (row.controls['valorTotalLiquido'].value * row.controls['ipiPercentual'].value) / 100
    );
  }

  incluirDoctoI(item: FatDoctoI) {
    console.log('incluirDoctoI');
    const produto = this.produto;
    console.log(`produto>>>>>>: ${JSON.stringify(produto)}`);

    if (produto === undefined || produto === null) {
      this.confirmService.confirm({
        message: `Produto Não Selecionado. Selecione um Produto e Click em Adicionar Item !!`,
        error: true,
      });
      return;
    }

    const ctrl = this.doctoCForm?.value?.controle;

    if (ctrl === undefined || ctrl === null || ctrl === 0) {
      this.confirmService.confirm({
        message: `Por favor, salve o lançamento e clique em Adicionar Item !!`,
        error: true,
      });
      return;
    }

    this.doctoCForm.patchValue({ produtoSearch: '' });

    this.precoPadrao = this.produto.precos.filter(
      (preco) =>
        preco.tabelaId === this.doctoCForm.value.fatListaPrecoTabela.id.tabelaId &&
        preco.listaId === this.doctoCForm.value.fatListaPreco.id
    );

    item = {} as FatDoctoI;
    item.id = {} as ItemID;
    item.id.fatProduto = produto;
    item.id.fatDoctoCControle = this.lcto.controle;
    item.qtde = 1;
    item.valorUnitario = this.precoPadrao[0]?.preco ?? 0;
    item.valorTotal = this.precoPadrao[0]?.preco ?? 0;
    item.descPercUnitario = 0.000;
    item.descValorUnitario = 0.0;

    this.zone.run(() => {
      const currentItems = this.doctoIs$.value || [];
      this.doctoIs$.next([item, ...currentItems]);
    });

    this.reloadFormItens();

    if (!this.layoutConf.isMobile) {
      this.isEditableDoctI[0] = true;
      this.isEditableParcela[0] = true;
    } else {
      this.save(false, false);
      this.editDoctoI(item);
    }

    setTimeout(() => {
      const elem = this.renderer.selectRootElement('#qtde');
      this.renderer.listen(elem, 'focus', () => {
        console.log('focus');
      });
      this.renderer.listen(elem, 'blur', () => {
        console.log('blur');
      });
      elem.focus();
    }, 100);
  }

  getPageItem(page: number, pageSize: number, controle: number) {
    if (controle !== undefined) {
      this.fatDoctoCService
        .getPageItem(this.lcto?.controle, page, pageSize, this.selectedItemOrdem, this.selectedItemDirect)
        .subscribe(
          (val) => {
            this.pageObjectDoctoI$.next(val);
            this.loader.close();
          },
          (err) => {
            this.loader.close();
            this.confirmService.confirm({
              title: 'ERRO AO PESQUISAR ITENS',
              message: err.error.status,
              error: true,
            });
          }
        );
    }
  }

  reloadPageItem() {
    this.pageItem = 1;
    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
  }

  getSearchPageItem(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginatorItem.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPageItem(1, this.pageSizeItem, this.lcto?.controle);
    } else {
      this.fatDoctoCService
        .getPageItemSearch(this.lcto?.controle, page, pageSize, search, this.selectedItemOrdem, this.selectedItemDirect)
        .subscribe((val) => {
          this.pageObjectDoctoI$.next(val);
        });
    }
  }

  setPageSizeOptionsItem(event: PageEvent) {
    console.log('setPageSizeOptionsItem');
    console.log(`event.pageSize ${event.pageSize}`);
    this.pageSizeItem = event.pageSize;
    if (this.itemFormArray.dirty) {
      this.save();
    }
    if (this.searchInput.length > 0) {
      this.getSearchPageItem(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPageItem(event.pageIndex + 1, event.pageSize, this.lcto?.controle);
    }
  }

  searchBy_UsingDebounceItem(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearchItem() {
    this.searchEntry$.pipe(debounceTime(250)).subscribe((s) => this.getSearchPageItem(s, 1, this.pageSizeItem));
  }

  askToSave() {
    this.confirmService.confirm({ message: `Salvar Lançamento?` }).subscribe((res) => {
      if (res) {
      }
    });
  }

  deleteDoctoI(row: any) {
    this.confirmService
      .confirm({ message: `Deletar ${row?.id.fatProduto.codigo + '-' + row?.id.fatProduto.descricao}?` })
      .subscribe((res) => {
        if (res) {
          setTimeout(() => (this.isEditableDoctI = {}), 300);
          this.fatDoctoCService.deleteItem(this.lcto?.controle, row.id.fatProduto.id).subscribe(
            (data2) => {
              this.loader.close();
              this.reloadPageItem();
              this.confirmService.confirm({
                title: !data2.erro ? 'Sucesso' : 'Erro',
                message: data2.status,
                error: true,
              });
              if (!data2.erro) {
                this.getPageItem(
                  this.pageObjectDoctoI$?.value?.content.length > 1 ? this.pageItem : this.pageItem - 1,
                  this.pageSizeItem,
                  this.lcto?.controle
                );
              }
            },
            (err) => {
              this.loader.close();
              this.reloadPageItem();
            }
          );
        }
      });
  }

  onFocusProduto(event: FocusEvent) {
    this.doctoCForm
      .get('produtoSearch')
      .valueChanges.pipe(
        debounceTime(100),
        tap(() => (this.searching = true)),
        switchMap((value) =>
          typeof value === 'string'
            ? value !== undefined && value !== ''
              ? this.produtoService.getProdutoPageSearch(1, 10, value, 'NENHUM', 'ASC', false, false)
              : this.produtoService.getProdutoPage(1, 10, 'NENHUM', 'ASC', true)
            : new Observable<PageResult<Produto>>()
        ),
        finalize(() => (this.searching = false))
      )
      .subscribe((produtos) => this.produtos$.next(produtos.content));
  }

  onSelectionChangeProduto(event: any): void {
    if (event.value !== undefined) {
      this.produto = event.value;
      this.fatDoctoCService.getExistsItem(this.lcto?.controle, this.produto.id).subscribe((val) =>
        this.produtoItemExists$.next(val)
      );
    }
  }

  displayFnProduto(prod: Produto) {
    if (prod) {
      return `${prod.codigo.toString().padStart(6, '0')} - ${prod.descricao.trim()}`;
    }
  }

  private initLogItens() {
    this.it = 0;
    this.workDone = null;
    this.max = null;
  }

  save(previa = false, mostrarOk = true): BehaviorSubject<FatDoctoC> {
    const result = new BehaviorSubject<FatDoctoC>({} as FatDoctoC);
    const obs = new BehaviorSubject<Log>({} as Log);
    this.saveItem = true;
    this.openProgressLoader(obs);
    this.fatDoctoCService.saveOrUpdate(this.doctoCForm.value).subscribe(
      (val) => {
        this.reloadLctoItens(val);
        this.getPageItem(1, this.pageSizeItem, val.controle);
        console.log(val);
        this.deleteLog();
        if (!previa) {
          if (mostrarOk) {
            this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
            this.confirmService.confirm({
              title: 'SALVAR',
              message: 'OK, Lançamento Salvo com Sucesso!',
              error: true,
            });
          }
        }
        this.isEditableDoctI = {};
        this.isEditableParcela = {};
        result.next(val);
        this.saveItem = false;
      },
      (err) => {
        this.deleteLog();
        result.error(err);
        this.saveItem = false;
        this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR, VERIFIQUE',
          message: err.error.status,
          error: true,
        });
      }
    );
    return result;
  }

  fixaPesoBruto() {
    this.doctoCForm.controls['fixaPesoBruto'].patchValue(true);
  }

  fixaPesoLiquido() {
    this.doctoCForm.controls['fixaPesoLiquido'].patchValue(true);
  }

  fixaVolumes() {
    this.doctoCForm.controls['fixaVolumes'].patchValue(true);
  }

  changeDescPerc() {
    const descPerc = this.doctoCForm.controls['descontodoctoPerc'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    if (descPerc === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
    } else if (descPerc <= 100) {
      const descValor = totalProdutos * (descPerc / 100);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(descValor);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descPerc + ' maior que 100% , VERIFIQUE!',
        error: true,
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }

  changeDescValor() {
    const descValor = this.doctoCForm.controls['descontodoctoValor'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    if (descValor === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    } else if (descValor <= totalProdutos) {
      const result = ((totalProdutos - (totalProdutos - descValor)) * 100) / totalProdutos;
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(result);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message:
          'Valor desconto: ' + descValor + ' maior que o Total dos produtos:' + totalProdutos + 'VERIFIQUE!',
        error: true,
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }

  recalcTotal() {
    const totalliquidoprodutos = this.doctoCForm.controls['totalliquidoprodutos']?.value || 0;
    const freteValor = this.doctoCForm.controls['freteValor']?.value || 0;
    const despesaValor = this.doctoCForm.controls['despesaValor']?.value || 0;
    const ipiValor = this.doctoCForm.controls['ipiValor']?.value || 0;
    const icmssubstValor = this.doctoCForm.controls['icmssubstValor']?.value || 0;
    const seguroValor = this.doctoCForm.controls['seguroValor']?.value || 0;
    const icmsDesonValor = this.doctoCForm.controls['icmsDesonValor']?.value || 0;
    const descontodoctoValor = this.doctoCForm.controls['descontodoctoValor']?.value || 0;

    this.doctoCForm.controls['valortotalDocto'].patchValue(
      totalliquidoprodutos +
        freteValor +
        despesaValor +
        ipiValor +
        icmssubstValor +
        seguroValor -
        icmsDesonValor -
        descontodoctoValor
    );
  }

  submit() {
    if (this.doctoCForm.valid) {
      console.log('form submitted');
    } else {
      this.validateAllFormFields(this.doctoCForm);
    }
  }

  private deleteLog() {
    this.fatDoctoCService.deleteLog(this.lcto?.uuid).subscribe((log) => {
      this.progressLoader.close();
    });
  }

  private openProgressLoader(obs: BehaviorSubject<Log>) {
    this.progressLoader.open(obs);
    timer(1, 1500)
      .pipe(
        switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
        retry(),
        share(),
        takeUntil(this.stopPolling)
      )
      .subscribe(
        (valor) => {
          if (this.max === valor.max && this.workDone === valor.workDone) {
            this.it = this.it + 1;
          } else {
            this.it = 0;
          }
          this.max = valor.max;
          this.workDone = valor.workDone;
          if (
            (valor.workDone !== null &&
              valor.workDone !== undefined &&
              valor.max != null &&
              valor.max !== undefined &&
              valor.workDone >= valor.max) ||
            this.it === this.maxRetry
          ) {
            this.stopPolling.next();
            this.initLogItens();
          }
          obs.next(valor);
        },
        (err) => {
          this.loader.close();
          this.confirmService.confirm({
            title: 'ERRO AO EXECUTAR OPERAÇÃO',
            message: err.error.status,
            error: true,
          });
        }
      );
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  isFieldValid(field: string) {
    return !this.doctoCForm.get(field)?.valid && this.doctoCForm.get(field)?.touched;
  }

  close() {
    this.dialogRef.close();
  }

  saveDoctoI(rowIndex: string) {
    this.isEditableDoctI[rowIndex] = !this.isEditableDoctI[rowIndex];
    this.save(false, false);
    this.reloadPageItem();
  }

  editDoctoIDI(row: any) {
    console.log('editDoctoIDI', row);
    let title = `ITEM: [  ${row?.id?.fatProduto?.codigo.toString().padStart(9, '0')} - ${
      row?.id?.fatProduto?.descricao
    } DI-Declaração(s) de Importação ]`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoItemDIListComponent, {
      width: this.layout.isMobile ? '100%' : '98%',
      disableClose: true,
      data: { title: title, payload: row },
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.reloadPageItem();
      if (!res) {
        return;
      }
      this.reloadLctoItens(this.lcto);
    });
  }

  editDoctoI(row: any) {
    console.log('editDoctoI', row);
    let title = `ITEM: [  ${row?.id?.fatProduto?.codigo.toString().padStart(9, '0')} - ${
      row?.id?.fatProduto?.descricao
    } ]`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoItemDetailsComponent, {
      width: this.layout.isMobile ? '100%' : '98%',
      disableClose: true,
      data: { title: title, payload: row },
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.reloadPageItem();
      if (!res) {
        return;
      }
    });
  }

  trackByFn(index, item) {
    return item.id.fatProduto.id;
  }

   openProdutoDetails(produto: Produto) {
    console.log('openProdutoDetails', produto);
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoDetailsComponent, {
      width: '80%',  
      height: '90%',  
      disableClose: true,  
      data: { produto: produto }, // Passa o produto como dado para o popup
    });
  
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snack.open('Produto atualizado com sucesso!', 'OK', {
          duration: 5500,
          verticalPosition: 'top',
        });
      }
    });
  }
   openManutencaoPreco(produto: Produto) {
    console.log('openManutencaoPreco', produto);
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoManutencaoPrecoComponent, {
      width: '80%',  
      height: '90%',  
      disableClose: true,  
      data: { produto: produto }, // Passa o produto como dado para o popup
    });
  
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snack.open('Produto atualizado com sucesso!', 'OK', {
          duration: 5500,
          verticalPosition: 'top',
        });
      }
    });
  }

// Ordena o FormArray "items" por código (numérico) ou descrição (texto)
  sortByProduto(by: 'codigo' | 'descricao') {
    const arr = this.itemFormArray as FormArray;
    if (!arr || !arr.controls?.length) return;

    const controls = arr.controls.slice().sort((a: any, b: any) => {
      const pa = a?.value?.id?.fatProduto ?? {};
      const pb = b?.value?.id?.fatProduto ?? {};

      const va = by === 'codigo'
        ? Number(pa.codigo ?? 0)
        : String(pa.descricao ?? '').toLocaleLowerCase();

      const vb = by === 'codigo'
        ? Number(pb.codigo ?? 0)
        : String(pb.descricao ?? '').toLocaleLowerCase();

      if (va < vb) return -1;
      if (va > vb) return 1;
      return 0;
    });

    // Recria o FormArray na ordem ordenada
    while (arr.length) arr.removeAt(arr.length - 1);
    controls.forEach(c => arr.push(c));

    // Sempre mantém ordem ascendente
    this.sortDir[by] = 'asc';
    this.cdr.markForCheck?.();
  }

  

}